import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './locales/ko.json';
import en from './locales/en.json';

// Read language from the existing settings storage key used by SettingsContext
const getInitialLanguage = (): string => {
  try {
    const stored = localStorage.getItem('proposalcraft_settings');
    if (stored) {
      const parsed = JSON.parse(stored) as { language?: string };
      if (parsed.language === 'en' || parsed.language === 'ko') {
        return parsed.language;
      }
    }
  } catch {
    // Ignore parse errors and fall through to default
  }
  return 'ko';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
